export default {
  route: {
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    draggableDialog: 'Draggable Dialog',
    draggableKanban: 'Draggable Kanban',
    draggableList: 'Draggable List',
    draggableSelect: 'Draggable Select',
    charts: 'Charts',
    barChart: 'Bar Chart',
    lineChart: 'Line Chart',
    mixedChart: 'Mixed Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    'menu1-1': 'Menu 1-1',
    'menu1-2': 'Menu 1-2',
    'menu1-2-1': 'Menu 1-2-1',
    'menu1-2-2': 'Menu 1-2-2',
    'menu1-3': 'Menu 1-3',
    menu2: 'Menu 2',
    table: 'Table',
    dynamicTable: 'Dynamic Table',
    draggableTable: 'Draggable Table',
    inlineEditTable: 'Inline Edit Table',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    mobile: 'App Localizations',
    applocalizations: 'App Localizations',
    otafiles: 'Ota Files',
    betaGroups: 'Beta Groups',
    caneAudioPacks: 'Cane Audio Packs',
    'redirect-weassist': 'WeAssist Panel Login',
    callLogs: 'Call Logs',
    bulkGrantCleanup: 'Bulk Grant Cleanup',
    subscriptionAudit: 'Subscription Audit',
    aimAnalytics: 'AIM Analytics',
    diagnostics: 'Cane Diagnostics',
    adminUsers: 'Create User',
    appleNotifications: 'Apple Notifications',
    savedRoutes: 'Saved Routes',
    applocalizations_detail: 'Localization Detail',
    appcoupons: 'Coupon Codes',
    users: 'Users',
    listUser: 'List User',
    activations: 'Cane Activations',
    authEvents: 'Auth Events',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboard: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    wewalkPage: 'WeWALK',
    profile: 'Profile',
    mobility: 'Mobility',
    addTrainerTrainee: 'Add Trainer/Trainee',
    listOrEditTrainerTrainee: 'List/Edit Trainers/Trainees',
    danis: 'WeASSIST',
    danisconfig: 'WeASSIST Config',
    freeZone: 'FreeZone',
    company: 'WeASSIST Company',
    packageManagment: 'Package Management',
    assistantConfig: 'Assistant Config',
    navigationConfig: 'Navigation Config',
    appSettings: 'App Settings',
    placesProvider: 'Places Service',
    placesCompare: 'Provider Comparison',
    mcp: 'MCP Access',
    configs: 'Configs',
    storeVersion: 'Store Version',
    contracts: 'Contracts',
    contractManagement: 'Contract Management',
    userActivations: 'User Activations',
    callEvents: 'Call Events',
    sessions: 'Sessions',
    subject: 'Subject',
    brand: 'Brand',
    brandSubject: 'Brand Subject',
    entitlements: 'Entitlements',
    features: 'Features',
    devices: 'Devices',
    userEntitlements: 'User Entitlements',
    purchases: 'Purchases',
    entitlementProducts: 'Entitlement Products',
    analytics: 'Analytics',
    businessAnalytics: 'Business Analytics',
    kpiAnalytics: 'KPI Analytics',
    referrals: 'Referrals',
    zoho: 'Zoho Integration',
    storeDashboard: 'Store Dashboard',
    subscriptionEvents: 'Subscription Events',
    webhookLogs: 'Webhook Logs',
    voiceAssistant: 'Voice Assistant',
    entitlementRules: 'Entitlement Rules',
    subscriptionSystem: 'Subscription System',
    notifications: 'Notifications',
    notificationLogs: 'Notification Logs',
    pendingGrants: 'Promised Features',
    skuManagement: 'SKU Management',
    warrantyPeriods: 'Warranty Periods',
    campaigns: 'Campaigns',
    monthlyCredits: 'Monthly Credits',
    aimData: 'AIM Data',
    externalApiKeys: 'External API Keys',
    bulkGrant: 'Bulk Grant',
    reporting: 'Reporting'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    theme: 'Theme',
    size: 'Global Size',
    profile: 'Profile'
  },
  login: {
    title: 'WeWALK Admin',
    logIn: 'Login',
    sendCode: 'Send Code',
    enterCode: 'Validation Code',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips:
      'Can not be simulated on local, so please combine you own business simulation! ! !',
    timeUpResendCode: 'Time Up',
    countryCode: 'Country Code',
    phoneNumber: 'Phone Number',
    loginError: 'An error occured while signing you in, please try again or contact the administrator',
    loginErrorTitle: 'Error !',
    loginWarningTitle: 'Warning !',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone.',
    notAdmin: 'You are not an administrator.\nPlease contact the WeWALK System & Development Team',
    invalidPhoneLength: 'Invalid phone number length. Phone number length must be 10 character long.',
    invalidCountry: 'SMS sending is only possible for Türkiye (+90). Please try logging in with email.',
    timeUpSecondsLeft: '{seconds} seconds left.',
    resendCode: 'Resend Code',
    loginWithPhone: 'Login with phone',
    loginWithEmail: 'Login with email'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    createRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description:
      'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips:
      'Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.',
    stickyTips:
      'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1:
      'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2:
      'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips:
      'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.',
    changeLanguageTips: 'Switch Language Success'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Importance',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'Reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    save: 'Save',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    update: 'Update',
    enableBeta: 'Enable Beta',
    disableBeta: 'Disable Beta',
    cancel: 'Cancel',
    confirm: 'Confirm',
    isPremium: 'Is Premium?',
    isBetaUser: 'Is Beta User?',
    isAssistant: 'Is Assistant User?',
    clientType: 'Client Type',
    expireDate: 'Expire Date',
    couponCode: 'Coupon Code',
    limit: 'Limit',
    productIds: "Product ID's",
    productIdForIOS: 'iOS Product ID',
    productIdForAndroid: 'Android Product ID',
    createTrainingRelation: 'Create',
    enableConsult: 'Enable WeASSIST',
    disableConsult: 'Disable WeASSIST',
    country: 'Country',
    userIdSearch: 'User ID Search',
    source: 'Source',
    loginType: 'Login Type',
    basePlanIdForAndroid: 'Android Base Plan Id',
    offerIdForAndroid: 'Android Offer Id',
    offerIdForIOS: 'IOS Offer Id'
  },
  appleNotif: {
    introTitle: 'Apple notification reconciliation',
    introBody: 'Apple retries a notification our endpoint refused, but one that got a 200 never comes back. So renewals, cancellations and refunds that arrive while the endpoint answers without processing anything are lost for good. This screen asks Apple what it sent, compares that with our own record, and can replay the difference.',
    lastHours: 'Last {h} hours',
    check: 'Check',
    replayMissing: 'Replay missing ({n})',
    statSent: 'Sent by Apple',
    statProcessed: 'Processed',
    statMissing: 'Missing',
    statReplayed: 'Replayed',
    colStatus: 'Status',
    colNotification: 'Notification',
    colProduct: 'Product',
    colTransaction: 'Transaction',
    colSentAt: 'Sent by Apple at',
    colFirstAttempt: 'First attempt',
    colReplay: 'Replay',
    processed: 'Processed',
    missing: 'Missing',
    emptyWindow: 'Apple sent no notifications in this window.',
    outcome_replayed: 'Replayed',
    outcome_no_action_needed: 'No action needed',
    outcome_handler_error: 'Handler error',
    outcome_failed: 'Failed',
    replayedN: '{n} notifications replayed',
    missingN: '{n} notifications look unprocessed',
    noneMissing: 'Nothing missing',
    replayConfirmTitle: 'Replay missing notifications',
    replayConfirmBody: '{n} notifications will be replayed through the same path a live delivery takes. The same notification is never applied twice. Continue?',
    continue: 'Continue',
    cancel: 'Cancel',
    errorNotConfigured: 'The Apple Store Server API is not configured in this environment, so Apple cannot be queried. APPLE_STORE_SERVER_KEY_ID, ISSUER_ID and KEY_PATH need to be set on the server.',
    errorGeneric: 'The check failed'
  },
  mcp: {
    introTitle: 'Read-only access for LLM clients',
    introBody: 'MCP is the protocol an AI client such as Claude uses to ask our system questions. A key issued here lets one person query users, canes, purchases and features from their own Claude Code setup. No tool can write, change or delete anything. A key belongs to a person, and the role of that person decides how much they see - an admin sees everything, a trainer only their own trainees, other roles nothing.',
    settingsTitle: 'Settings',
    piiLabel: 'Return personal data in the clear',
    piiNote: 'This is the default for keys that have not been set individually. While off, email, phone and name come back masked (h***n@gmail.com). To give one person unmasked access, set their key rather than this default. Changes take effect within 60 seconds, not instantly. Test and production hold this separately.',
    piiInherit: 'Follow default',
    piiForceOn: 'On for this key',
    piiForceOff: 'Off for this key',
    effectiveOn: 'currently on',
    effectiveOff: 'currently masked',
    piiKeyNote: 'You can decide separately for this key. Following the default is the right answer most of the time.',
    keyPiiConfirmBody: 'The key {label} will read user emails, phone numbers and names in plain text even while the panel default is off. Putting it back on the default when the work is done is recommended. Continue?',
    overrideTitle: 'Some keys override the default',
    overrideBody: '{on} key(s) read personal data regardless of the default, and {off} key(s) are pinned off. So the setting above being off does not on its own mean nobody can read personal data.',
    resetPii: 'Put every key back on the default',
    resetPiiConfirmBody: 'Every key that was set individually will follow the panel default again. Continue?',
    resetPiiDone: '{n} key(s) put back on the default',
    piiOn: 'On',
    piiOff: 'Off',
    piiConfirmTitle: 'Reveal personal data',
    piiConfirmBody: 'While this is on, anyone holding an MCP key can read user emails, phone numbers and names in plain text. Turning it back off when you are done is recommended. Continue?',
    endpoint: 'MCP address:',
    keysTitle: 'Keys',
    newKey: 'New key',
    label: 'Label',
    labelPlaceholder: 'e.g. Support - Ayse',
    owner: 'Owner',
    ownerEmail: 'User email',
    ownerNote: 'The WeWALK account the key belongs to. That person needs an admin or trainer role.',
    validFor: 'Valid for',
    days: 'days',
    status: 'Status',
    active: 'Active',
    passive: 'Inactive',
    expired: 'Expired',
    revoked: 'Revoked',
    expiresAt: 'Expires',
    lastUsed: 'Last used',
    calls: 'Calls',
    actions: 'Actions',
    revoke: 'Revoke',
    revokeConfirmTitle: 'Revoke key',
    revokeConfirmBody: 'The key {label} will stop working. This cannot be undone; a new key would have to be issued. Continue?',
    create: 'Create',
    cancel: 'Cancel',
    continue: 'Continue',
    done: 'Done',
    copy: 'Copy',
    copied: 'Copied',
    saved: 'Saved',
    failed: 'Request failed',
    fillAll: 'Email and label are required',
    keyReadyTitle: 'Key ready',
    keyOnceWarning: 'This key will not be shown again. Copy it now.',
    howtoTitle: 'Setup command for Claude Code',
    callsTitle: 'Call log',
    callsNote: 'Every request the server received. Rejected key attempts are recorded too - this is the first place to look when something goes wrong. Results are not stored, only what was asked.',
    last7: 'Last 7 days',
    rejected: 'Rejected',
    errors: 'Errors',
    withPii: 'With personal data on',
    subject: 'Subject',
    subjectPlaceholder: 'Email, serial or search term',
    onlyProblems: 'Problems only',
    search: 'Search',
    method: 'Method',
    keyPrefix: 'Key prefix',
    client: 'Client',
    userAgent: 'User agent',
    error: 'Error',
    okShort: 'OK',
    unknownKey: 'Unrecognised key',
    unknownKeyNote: 'The key presented did not resolve to anybody: expired, revoked, from the wrong environment, or never issued. The key prefix tells you which.',
    time: 'Time',
    tool: 'Tool',
    arguments: 'Arguments',
    result: 'Result',
    rows: 'rows',
    pii: 'PII',
    duration: 'Duration',
    refresh: 'Refresh'
  },
  placesCompare: {
    introTitle: 'One query, two providers, side by side',
    introBody: 'Runs the exact lookup the app makes through both Google Places and Geoapify and shows both answers next to each other. This screen only reads; it never changes which provider is live. Rows marked orange were found by that provider alone.',
    preset: 'Area',
    latitude: 'Latitude',
    longitude: 'Longitude',
    category: 'Category',
    query: 'Text search',
    queryPlaceholder: 'e.g. pharmacy',
    radius: 'Radius (m)',
    fresh: 'Skip cache',
    run: 'Compare',
    hintCategory: 'Running a category lookup. Typing a text search compares search instead of category.',
    hintSearch: 'Comparing text search. Google uses text search, Geoapify uses address/place autocomplete.',
    shared: 'Shared',
    verdictNone: 'The two providers returned no venue in common. The reason is ranking, not disagreement: Google returns the prominent places, Geoapify the nearest ones. The same 20-result cap cuts a different slice of the same street.',
    verdictSome: 'There are shared venues, but the lists are largely different. Google ranks by prominence, Geoapify by distance.',
    count: 'Results',
    nearest: 'Nearest',
    farthest: 'Farthest',
    onlyHere: 'Only here',
    withPhone: 'Phone',
    withWebsite: 'Web',
    withRating: 'Rating',
    phone: 'phone',
    website: 'web',
    rating: 'rating',
    noRun: 'No query run yet',
    noResult: 'No results',
    failed: 'Comparison failed',
    cat_all: 'All',
    cat_food: 'Food & drink',
    cat_shop: 'Shops',
    cat_pubs: 'Bars / nightlife',
    cat_art: 'Art & culture',
    cat_college: 'Education',
    cat_fitness: 'Sport / health',
    cat_professional: 'Services / offices'
  },
  placesProvider: {
    introTitle: 'This setting changes every venue in the app',
    introBody: 'The service you pick supplies nearby places, searches and venue details. A change reaches every user within a minute, with no deploy. The providers do not return the same data: the table below shows what each one can answer.',
    cardTitle: 'Places service',
    active: 'Answering now',
    fallback: 'Fallback (if the setting cannot be read)',
    save: 'Switch',
    refresh: 'Refresh',
    confirmTitle: 'Switch places service',
    confirmBody: 'Venue data will start coming from {name} for every user. You can switch back from this screen if something looks wrong. Continue?',
    continue: 'Continue',
    cancel: 'Cancel',
    saved: 'Switched',
    failed: 'That did not work',
    note_googleplaces: 'The richest data. Includes ratings, reviews, photos and business details.',
    note_geoapify: 'Backed by OpenStreetMap. Location and basics are there; no ratings, reviews or photos.',
    note_foursquare: 'The older provider. Not in use.',
    fieldsTitle: 'What each provider can answer',
    fieldsBody: 'Geoapify uses OpenStreetMap data. Fields it cannot supply come back null rather than zero, so the app can hide the row instead of showing a value that is not true.',
    field: 'Field'
  },
  pendingGrants: {
    introTitle: 'Promised features',
    introBody: 'Features promised at the point of sale wait here until their buyer has an account. They are handed over automatically when the person registers, signs in, or corrects their email. A row that never gets claimed usually means one thing: the buyer registered with a different address than the sale recorded, and somebody has to assign it by hand.',
    email: 'Email',
    feature: 'Feature',
    source: 'Source',
    status: 'Status',
    waiting: 'Waiting',
    actions: 'Actions',
    statusAll: 'All',
    status_pending: 'Pending',
    status_claimed: 'Claimed',
    status_cancelled: 'Cancelled',
    searchPlaceholder: 'Search email',
    sweep: 'Sweep',
    addManual: 'Add manually',
    importFromCrm: 'Import from CRM',
    staleTitle: '{n} promises unclaimed for more than {days} days',
    staleBody: 'These buyers most likely registered with a different address. Reach out for the right one, or find the account and assign it by hand.',
    nDays: '{n} days',
    assign: 'Assign',
    cancel: 'Cancel',
    revoke: 'Revoke',
    assignTitle: 'Assign to an account',
    assignBody: 'The {feature} promised to {email} will be handed to the account you pick.',
    userSearchPlaceholder: 'Search by email or name (at least 2 characters)',
    assigned: 'Assigned',
    close: 'Close',
    save: 'Save',
    continue: 'Continue',
    confirmTitle: 'Confirm',
    saved: 'Saved',
    cancelled: 'Cancelled',
    failed: 'That did not work',
    durationType: 'Duration',
    durationValue: 'Length',
    years: 'years',
    months: 'months',
    days: 'days',
    permanent: 'Permanent',
    durationNote: 'The duration starts when the feature is handed over, not when it was sold. Someone registering six months later still gets a full year.',
    notes: 'Notes',
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email',
    featureRequired: 'Pick a feature',
    cancelConfirm: 'The {feature} promise will be cancelled. It has not been claimed, so there is nothing to take back. Continue?',
    revokeConfirm: '{feature} will be REVOKED from the user. Continue?',
    sweepDone: '{checked} addresses checked, {claimed} promises handed over',
    importTitle: 'Import from the CRM',
    sourceContacts: 'Contacts',
    sourceDeals: 'Deals',
    contactsNote: 'Reads the "WeWALK: features to grant" field on the contact. This also runs on its own every hour; use this to skip the wait.',
    dealsNote: 'Reads the line items on a deal. Most deals have none, so Contacts is normally the one to use.',
    emailsPlaceholder: 'Or emails (comma separated)',
    typed: 'Field value',
    unknownTokens: 'Not recognised: {tokens}',
    contactImportSummary: '{contactsSeen} contacts read, {grantsCreated} promises created, {claimedImmediately} handed over immediately, {unreadable} with unrecognised values, {withoutEmail} without an email',
    outcome_no_email: 'No email',
    outcome_empty: 'Field empty',
    outcome_no_recognised_features: 'Not recognised',
    importWarnTitle: 'Do a dry run first',
    importWarnBody: 'A dry run writes nothing and only shows what would happen. Review it before applying. A wide window can turn years of past sales into promises.',
    lastHours: 'Last {h} hours',
    dealIdsPlaceholder: 'Or deal ids (comma separated)',
    dryRun: 'Dry run',
    apply: 'Apply',
    applyConfirm: 'Pending grants will be created for the sales listed. The same sale never creates two. Continue?',
    importApplied: '{n} promises created',
    importSummary: '{dealsSeen} sales read, {grantsCreated} promises created, {claimedImmediately} handed over immediately, {withoutContactEmail} without an email, {withoutFeatures} with no feature-bearing product',
    deal: 'Deal',
    outcome: 'Outcome',
    outcome_created: 'Created',
    outcome_would_create: 'Would create',
    outcome_no_line_items: 'No line items',
    outcome_no_features_on_skus: 'No features',
    outcome_no_contact_email: 'No email',
    empty: 'Nothing found'
  },
  adminUsers: {
    tabSingle: 'Single user',
    tabBulk: 'Bulk from Excel',
    bulkStep1: '1. Download the template',
    downloadTemplate: 'Download template',
    bulkColumnsHint: 'Do not change the column headers. They are the same in both languages; upper or lower case does not matter.',
    colColumn: 'Column',
    colRequired: 'Status',
    colMeaning: 'Meaning',
    required: 'Required',
    docEmail: 'The email the person will use to sign in to the WeWalk app',
    docFirstName: 'First name. If unknown, guess from the address; it can be corrected later',
    docLastName: 'Last name',
    docCountryCode: 'Country code, digits only (e.g. 49). Required if you enter a phone',
    docPhoneNumber: 'Phone, digits only. Leave empty rather than inventing a number',
    bulkStep2: '2. Upload the completed file',
    bulkStep3: '3. Review and create',
    bulkSummary: '{ready} rows ready, {invalid} rows with errors',
    invalidSkipped: 'Rows with errors will be skipped and the rest created. You can fix them and upload the file again.',
    rowNo: 'Row',
    status: 'Status',
    status_ready: 'Ready',
    status_invalid: 'Invalid',
    status_creating: 'Creating',
    status_created: 'Created',
    status_failed: 'Failed',
    createN: 'Create {n} users',
    downloadResults: 'Download results',
    bulkConfirmTitle: 'Bulk creation',
    bulkConfirmBody: '{n} accounts will be created. Each address then counts as registered, and these people must sign in rather than sign up. Continue?',
    continue: 'Continue',
    cancel: 'Cancel',
    fileLoaded: '{n} rows read',
    fileEmpty: 'No rows found in the file',
    fileTooLarge: 'The file must be smaller than 5 MB',
    tooManyRows: 'You can upload at most {max} rows at a time',
    duplicateInFile: 'This email appears more than once in the file',
    bulkDone: '{ok} users created',
    bulkDoneWithErrors: '{ok} users created, {failed} rows failed',
    introTitle: 'What creating an account does to its owner',
    introBody: 'The moment the account exists, that email counts as registered. If the person taps <b>Sign Up</b> in the app they will be told the email is already registered; they have to tap <b>Sign In</b> instead. The sign-in code still goes to their own mailbox, so neither you nor anyone else can get into an account created here. Make sure you tell them to sign in rather than sign up.',
    newUser: 'New user',
    email: 'Email',
    emailPlaceholder: 'name@example.com',
    firstName: 'First name',
    lastName: 'Last name',
    fullName: 'Name',
    countryCode: 'Country code',
    countryCodePlaceholder: '49',
    phone: 'Phone',
    optional: 'optional',
    phoneHint: 'Phone is optional and can be left empty. Do not invent a number: if it turns out to belong to a real person, that person will not be able to register.',
    create: 'Create user',
    clear: 'Clear',
    createdThisSession: 'Created in this session',
    noneYet: 'You have not created any users yet.',
    userId: 'User ID',
    createdMessage: '{email} created',
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email address',
    firstNameRequired: 'First name is required',
    phonePairRequired: 'Country code and phone go together: fill in both or leave both empty',
    errorEmailTaken: 'This email is already registered. The person should sign in instead.',
    errorPhoneTaken: 'This phone number belongs to another account.',
    errorEmailInvalid: 'The email address is not valid.',
    errorFirstNameRequired: 'First name is required.',
    errorPhoneIncomplete: 'Country code and phone must be filled in together.',
    errorGeneric: 'Could not create the user'
  },
  savedPlaces: {
    tab: 'Saved Places',
    refresh: 'Refresh',
    addNew: 'Add New Place',
    editPlace: 'Edit Place',
    title: 'Title',
    address: 'Address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    type: 'Type',
    actions: 'Actions',
    empty: 'No saved places found',
    typeMyLocation: 'My Location (mylocation)',
    typeExploration: 'Exploration (exploration)',
    typeStation: 'Station (station)',
    editNote: 'Note: coordinates and type can only be set when adding a new place; editing updates title and address.',
    coordsRequired: 'Latitude and longitude are required',
    saved: 'Saved',
    saveFailed: 'Could not save',
    deleteConfirm: 'Delete this saved place?',
    confirmTitle: 'Confirm',
    deleted: 'Deleted',
    deleteFailed: 'Could not delete',
    fetchFailed: 'Could not load saved places',
    save: 'Save',
    cancel: 'Cancel',
    titlePlaceholder: 'Home, Work, ...'
  },
  savedRoutes: {
    create: 'New Route',
    createTitle: 'Create Route',
    forUser: 'User',
    userSearchPlaceholder: 'Search by email or name (at least 2 characters)',
    userRequired: 'Pick a user',
    titleRequired: 'Title is required',
    points: 'Start and End',
    clickToPlace: 'Click the map to place, or drag the marker:',
    address: 'Address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    coordInvalid: 'Enter a valid coordinate',
    tab: 'Routes',
    pageTitle: 'Saved Routes',
    refresh: 'Refresh',
    title: 'Title',
    user: 'User',
    visibility: 'Visibility',
    visibilityPrivate: 'Private',
    visibilityPublic: 'Public',
    start: 'Start',
    end: 'End',
    distance: 'Distance',
    duration: 'Duration',
    trackPoints: 'Track Points',
    source: 'Source',
    date: 'Date',
    actions: 'Actions',
    empty: 'No saved routes found',
    detailTitle: 'Route Detail',
    description: 'Description',
    waypoints: 'Waypoints',
    makePublic: 'Make Public',
    makePrivate: 'Make Private',
    visibilityUpdated: 'Visibility updated',
    visibilityUpdateFailed: 'Could not update visibility',
    deleteConfirm: 'Delete this route?',
    confirmTitle: 'Confirm',
    deleted: 'Deleted',
    deleteFailed: 'Could not delete',
    fetchFailed: 'Could not load routes',
    saved: 'Saved',
    saveFailed: 'Could not save',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    editTitle: 'Edit Route',
    searchPlaceholder: 'Title or user email',
    all: 'All'
  },
  example: {
    warning:
      "Creating and editing pages cannot be cached by keep-alive because keep-alive's 'include' currently does not support caching based on routes, so now it's cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or don't use keep-alive's 'include' to cache all pages directly. See details"
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description:
      'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name (default file)'
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading PDF.'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    showTagsView: 'Open Tags-View',
    showSidebarLogo: 'Sidebar Logo',
    fixedHeader: 'Fixed Header',
    sidebarTextTheme: 'Sidebar Text Theme'
  },
  columnType: {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    countryCode: 'Country Phone Code',
    country: 'Country Name',
    city: 'City Name',
    userType: 'User type',
    caneId: 'Cane ID',
    minutes: 'Minutes',
    assistant: 'Assistant',
    phoneNumber: 'Phone Number',
    assistantRegion: 'Assistant Region',
    isPremium: 'Is Premium'
  },
  package: {
    yearly: 'Yearly',
    monthly: 'Monthly',
    'monthly-consult': 'WeASSIST - Monthly',
    additional: 'Additional',
    'additional-consult': 'WeASSIST - Additional',
    minutes: 'minutes',
    general: 'General',
    android: 'Android',
    ios: 'iOS',
    code: 'Package Code',
    name: 'Package Name',
    platform: 'Platform Information',
    type: 'Package Type',
    balance: 'Package Balance',
    order: 'Package Order',
    state: 'State',
    active: 'Active',
    passive: 'Passive',
    edit: 'Edit',
    description: 'Description',
    buttonText: 'Button Text',
    addNewPackage: 'Add New Package',
    isFirstSubscription: 'Gift Package for New Users',
    title: 'Package Title',
    testPackage: 'Visibility',
    isTest: 'Test Package',
    isTestHint: 'Only visible to specified test users',
    testUsers: 'Test Users',
    testUsersPlaceholder: 'Enter email addresses separated by commas (e.g., user1@email.com, user2@email.com)'
  },
  freeZone: {
    addNewSponsor: 'Add New Sponsor',
    name: 'Name',
    company: 'Company',
    latitude: 'Latitude',
    longitude: 'Longitude',
    range: 'Range',
    isCity: 'Is City',
    state: 'State',
    active: 'Active',
    passive: 'Passive',
    yes: 'Yes',
    no: 'No',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    deletePopup: 'Are you sure you want to delete the sponsor information ?',
    cancel: 'Cancel',
    ok: 'Ok',
    dataNotAvailable: 'There is no data available'
  },

  assistantConfig: {
    addNewAssistantConfig: 'Added New Assistant Config',
    region: 'Region',
    workingHoursStart: 'Working Hours Start',
    workingHoursEnd: 'Working Hours End',
    workingHours: 'Working Hours',
    workingDays: 'Working Days',
    state: 'State',
    active: 'Active',
    yes: 'Yes',
    no: 'No',
    passive: 'Passive',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    deletePopup: 'Are you sure you want to delete the assistant config ',
    cancel: 'Cancel',
    ok: 'Ok',
    timezone: 'Timezone',
    dataNotAvailable: 'There is no data available'
  },
  company: {
    addNewCompany: 'Add Company',
    name: 'Company Name',
    header: 'Company Header',
    description: 'Campaign Description',
    link: 'Campaign Link',
    order: 'Order',
    state: 'State',
    active: 'Active',
    passive: 'Passive',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    deletePopup: 'Are you sure you want to delete the company information ?',
    cancel: 'Cancel',
    ok: 'Ok',
    dataNotAvailable: 'There is no data available',
    region: 'Region'
  },
  subject: {
    addNewSubject: 'Add Subject',
    name: 'Subject Name',
    state: 'State',
    active: 'Active',
    passive: 'Passive',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    cancel: 'Cancel',
    ok: 'Ok',
    dataNotAvailable: 'There is no data available',
    region: 'Region'
  },
  brand: {
    addNewBrand: 'Add Brand',
    name: 'Brand Name',
    state: 'State',
    active: 'Active',
    passive: 'Passive',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    cancel: 'Cancel',
    ok: 'Ok',
    dataNotAvailable: 'There is no data available',
    region: 'Region'
  },
  brandSubject: {
    addNewBrandSubject: 'Add Brand Subject',
    consultSubjectName: 'Subject Name',
    consultBrandName: 'Brand Name',
    orderNo: 'Order No',
    isConsultFree: 'Is Consult Free',
    free: 'Free',
    paid: 'Paid',
    state: 'State',
    active: 'Active',
    passive: 'Passive',
    edit: 'Edit',
    delete: 'Delete',
    actions: 'Actions',
    cancel: 'Cancel',
    ok: 'Ok',
    dataNotAvailable: 'There is no data available',
    region: 'Region',
    regionPlaceholder: 'Select one or more countries',
    regionHint: 'Leave empty to apply to all countries.',
    allCountries: 'All countries'
  },
  localization: {
    addNewLocalization: 'Add Localization',
    import: 'Import',
    export: 'Export',
    search: 'Search',
    save: 'Save',
    updateVersion: 'Update Version',
    delete: 'Delete',
    confirmDeleteMessage: 'Are you sure you want to delete this row?',
    warning: 'Warning',
    yes: 'Yes',
    no: 'No',
    success: 'Success',
    error: 'Error',
    rowDeleted: 'Row deleted successfully!',
    deleteFailed: 'Failed to delete row.',
    versionUpdated: 'Version updated successfully!',
    emailSent: 'Successfully sent localization keys to',
    rowUpdated: 'Row updated successfully!',
    updateFailed: 'Failed to update row.',
    fileImported: 'File imported successfully!',
    importFailed: 'Failed to import file.',
    loading: 'Loading...',
    iosKey: 'IOS Key',
    androidKey: 'Android Key',
    enterIosKey: 'Enter IOS Key',
    enterAndroidKey: 'Enter Android Key',
    enterLanguage: 'Enter Language',
    enterValue: 'Enter Value',
    enterKey: 'Enter Key',
    languageKey: 'Language Key',
    value: 'Value',
    key: 'Key',
    actions: 'Actions',
    importInProgress: 'Import in progress...',
    confirmUpdateVersionMessage: 'Are you sure you want to update the localization version?',
    fileRequired: 'Please select a file before importing.',
    confirmImportMessage: 'Are you sure you want to import the selected file?',
    noErrorsFound: 'No errors found.',
    unknownError: 'An unknown error occurred.'
  },
  rules: {
    totalEvaluations: 'Total Evaluations',
    matchRate: 'Match Rate',
    featuresGranted: 'Features Granted',
    errors: 'Errors',
    avgDuration: 'Avg Duration',
    executionHistory: 'Execution History',
    date: 'Date',
    ruleName: 'Rule Name',
    triggerType: 'Trigger Type',
    matched: 'Matched',
    user: 'User',
    duration: 'Duration',
    conditionsContext: 'Conditions Context',
    grantedFeatures: 'Granted Features',
    errorMessage: 'Error Message',
    filterByRule: 'Filter by Rule',
    filterByMatch: 'Match Status',
    allRules: 'All Rules',
    matchedOnly: 'Matched',
    unmatchedOnly: 'Unmatched',
    noData: 'No execution data available',
    last30Days: 'Last 30 Days',
    last7Days: 'Last 7 Days',
    last90Days: 'Last 90 Days',
    sourceReference: 'Source Reference'
  },
  otaFiles: {
    pinOnly: 'Pin Only',
    pinOnlyCreateHint: "When enabled, this OTA is not rolled out to the general fleet — it can only be delivered to users it's manually pinned to. Can be toggled later via Edit.",
    pinOnlyEditHint: 'Disabling will make this OTA available to the general rollout.',
    overridesOlderPins: 'Override Older Pins',
    overridesOlderPinsHint: 'When enabled, this release invalidates any existing pin in the SAME major (e.g. 2.46.0 invalidates pins on 2.44.0 / 2.45.0) — pinned users fall back to normal rollout on their next OTA check. Cross-major safe (V3 release does not invalidate V2 pins).'
  },
  userDialog: {
    consultGranted: 'Granted: {min} min ({sec}s)',
    consultUsed: 'Used: {min} min ({sec}s)',
    consultRemaining: 'Remaining: {min} min ({sec}s)',
    callDate: 'Call Date',
    callDuration: 'Call Duration',
    deductedFromPackage: 'Deducted From This Package',
    minShort: 'min',
    overflow: 'overflow',
    noConsultDeductions: 'No recorded calls used minutes from this package (calls made before this feature went live are not shown here).',
    remaining: 'Remaining',
    used: 'Used',
    devicesTab: 'Devices & OTA',
    noActiveDevice: 'This user has no ACTIVE device.',
    installed: 'Installed:',
    previousVersion: '(previous: {version})',
    lastDownloadedOta: 'Last downloaded OTA:',
    legacyLog: 'legacy log (no device)',
    noData: 'no data',
    deleteAccount: 'Delete account',
    loadDevicePinFailed: 'Failed to load device/pin info: {msg}',
    deletionPreviewFailed: 'Failed to load deletion preview: {msg}',
    purgeConfirm: 'The account {target} will be permanently deleted: {rows} records will be deleted and {devices} canes will be unbound. This cannot be undone. Type the {field} to confirm.',
    purgeFieldEmail: 'email address',
    purgeFieldUserId: 'user ID',
    deletePermanently: 'Delete permanently',
    valueMismatch: 'Value does not match',
    accountDeleted: 'Account deleted',
    deleteAccountFailed: 'Failed to delete account: {msg}',
    justNow: 'just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    daysAgo: '{n} day ago | {n} days ago'
  },
  failedActivations: {
    searchTab: 'Search',
    tabLabel: 'Failed activations',
    description: 'The activation looks complete, but the cane is not bound to the user. In this state the cane\'s permanent features (Smart Map, Voice Assistant, Smart Cane Basic) never reach the user.',
    searchPlaceholder: 'Email, first name, last name or cane serial',
    search: 'Search',
    refresh: 'Refresh',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    caneSerial: 'Cane Serial',
    type: 'Type',
    issue: 'Issue',
    noDeviceRecord: 'No device record',
    unowned: 'Unowned',
    boundToAnotherUser: 'Bound to another user',
    deviceOwner: 'Device Owner',
    lostPermanentFeatures: 'Lost Permanent Features',
    featureCount: '{n} feature | {n} features',
    activation: 'Activation',
    action: 'Action',
    brokenSerialTooltip: 'Broken serial: the cane cannot report its real serial number. Look up the real serial from the label on the Devices screen and bind it with Connect.',
    brokenSerial: 'Broken serial',
    bindAndGrant: 'Bind and grant features',
    empty: 'No failed activations',
    bindConfirm: 'Cane {serial} will be bound to {email} and its features will be granted to this user. Continue?',
    bindTitle: 'Bind cane',
    bind: 'Bind',
    cancel: 'Cancel',
    bindSuccess: 'Cane bound, features granted',
    bindFailed: 'Binding failed',
    loadFailed: 'Failed to load failed activations'
  },
  devicesScreen: {
    zohoCheckedUpTo: 'Checked the Zoho package list up to page {page}. Serials not found may be on later pages.',
    scanNextZohoPage: 'Scan next Zoho page ({page})',
    managePins: 'Manage pins',
    managePinsFor: 'Manage pins - {serial}',
    deviceNotBound: 'Device is not bound to a user - cannot pin.',
    user: 'User:',
    installed: 'Installed:',
    pinsOnDevice: 'Pins on this device',
    applyUpdatePin: 'Apply / update pin',
    loadPinInfoFailed: 'Failed to load pin info: {msg}',
    loadDevicePinInfoFailed: 'Failed to load device pin info: {msg}',
    syncConfirm: 'Canes with missing features will be looked up in Zoho packages (Zoho page {page}, about 200 Zoho API calls, may take a few minutes). This step is a preview only; applying asks for separate confirmation. Continue?',
    startScan: 'Start scan'
  },
  otaPin: {
    allCanes: 'All canes (user-scope)',
    allCanesScope: 'all canes (user-scope)',
    delete: 'Delete',
    noPins: 'no pins',
    today: 'today',
    yesterday: 'yesterday',
    daysAgo: '{n} days ago',
    weeksAgo: '{n} wk ago',
    monthsAgo: '{n} mo ago',
    pinForAllUserCanes: 'Pin for all of the user\'s canes',
    userScopeHint: '(Saved with device_serial_number=NULL; applies even if the app sends no deviceSerial, the V2/V3 split is enforced on the server)',
    device: 'Device:',
    selectDevice: 'Select device',
    lastConnected: 'last connected',
    noActiveDevice: 'No active device - cannot pin',
    locked: 'locked',
    allCanesHint: 'Pin for all canes. Devices matching the selected OTA\'s major version get this pin, the rest stay on the rollout.',
    version: 'Version:',
    onlyMajorPinnable: '→ only {range} OTAs can be pinned.',
    alreadyPinned: 'Already pinned on this device: {version}',
    cannotPin: 'Cannot pin.',
    serialFormatMismatch: 'The selected device\'s serial number ({serial}) does not match the standard {format} format.',
    selectOtaVersion: 'Select OTA version',
    reasonPlaceholder: 'Reason (optional - e.g. \'crash repro\')',
    updatePin: 'Update pin',
    pin: 'Pin',
    pinUpdated: 'Pin updated',
    pinApplied: 'Pin applied',
    applyFailed: 'Failed to apply pin: {msg}',
    applyFailedCode: 'Failed to apply pin ({code})',
    unknownError: 'unknown error',
    removeConfirm: 'The {version} pin ({scope}) will be removed. Continue?',
    removeTitle: 'Remove pin',
    removeConfirmButton: 'Yes, remove',
    removed: 'Pin removed',
    removeFailed: 'Failed to remove pin: {msg}'
  },
  bulkGrantCleanup: {
    statActiveUsers: 'Users with active bulk grants',
    statDistinctBatches: 'Distinct bulk grant batches',
    statRevokedUsers: 'Users with bulk grants removed',
    statVerified: 'Verified',
    tabPending: 'Active bulk grants',
    tabRemoved: 'Removed bulk grants',
    byFeature: 'By feature:',
    clearFilter: 'Clear filter',
    deviceType: 'Device type',
    countryPlaceholder: 'Country (TR/US/...)',
    searchPlaceholder: 'Search: email / name / phone / serial no',
    filter: 'Filter',
    reset: 'Reset',
    selected: 'selected',
    clearSelection: 'Clear selection',
    removeBulkGrants: 'Remove bulk grants',
    removeAllMatching: 'Remove all matching',
    markReviewed: 'Mark as reviewed',
    restore: 'Restore',
    colDevice: 'Device',
    noDevice: 'no device',
    serialFormatWarning: 'Serial number does not match the standard WW-OZ-XXXXN-XXXXXX format — V2/V3 cannot be determined, so the cane cannot be pinned.',
    notPinnable: 'not pinnable',
    colUser: 'User',
    colCountry: 'Country',
    colBulkFeatures: 'Bulk / campaign features',
    noExpiry: 'No expiry',
    alternativeSources: 'Alternative sources:',
    colCleanupStatus: 'Cleanup status',
    otaInstalled: 'installed:',
    otaPrevious: 'previous:',
    otaLastDownloaded: 'last downloaded:',
    noData: 'no data',
    colActions: 'Actions',
    details: 'Details',
    detailTitleFor: '{name} — Details',
    userActivity: 'User activity',
    lastLogin: 'Last login',
    lastConsultCall: 'Last consult call',
    never: 'Never',
    consultCalls30d: 'Consult calls (30d)',
    consultMinutes30d: 'Consult minutes (30d)',
    minutesShort: '{n} min',
    devices: 'Devices',
    serialNo: 'Serial no',
    type: 'Type',
    status: 'Status',
    activation: 'Activation',
    noActiveDevices: 'This user has no active devices.',
    allEntitlements: 'All entitlements',
    rowCount: '{n} row | {n} rows',
    source: 'Source',
    start: 'Start',
    end: 'End',
    active: 'Active',
    revoked: 'Revoked',
    inactive: 'Inactive',
    otaVersion: 'OTA version',
    installedApp: 'Currently installed (app)',
    installedWireless: 'Currently installed (wireless)',
    previousApp: 'Previously installed (app)',
    previousWireless: 'Previously installed (wireless)',
    appReportedVersion: 'App-reported version (heartbeat)',
    lastDownloadedOta: 'Last downloaded OTA',
    manualPin: 'Manual pin (override)',
    activePins: '{n} active pin | {n} active pins',
    noPin: 'no pin — normal rollout',
    otaHelp: 'Users without a pin follow the normal rollout/canary flow. Once pinned, the user gets the selected version and the rollout percentage/major filter no longer apply.',
    actionHistory: 'Action history',
    time: 'Time',
    action: 'Action',
    affectedRows: 'Affected rows',
    performedBy: 'Performed by',
    removeBulkGrant: 'Remove bulk grant',
    restorePrevious: 'Restore previous removal',
    restoreConfirm: 'Removed bulk grants will be restored for {n} user. Continue? | Removed bulk grants will be restored for {n} users. Continue?',
    restoreConfirmTitle: 'Confirm restore',
    yesRestore: 'Yes, restore',
    cancel: 'Cancel',
    success: 'Success',
    error: 'Error',
    restoredSummary: '{users} user(s), {rows} row(s) restored',
    restoreFailed: 'Restore failed',
    revokeConfirm: 'Bulk grants will be removed for {n} user. Continue? | Bulk grants will be removed for {n} users. Continue?',
    revokeConfirmTitle: 'Confirm bulk grant removal',
    yesRemove: 'Yes, remove',
    removedSummary: '{users} user(s), {rows} row(s) removed',
    removeFailed: 'Removal failed',
    matchingFetchFailed: 'Could not fetch matching users',
    noMatchingUsers: 'No users with bulk grants match the current filter.',
    cappedNote: 'NOTE: The limit ({n}) was reached, there may be more. Narrow the filter and run again.',
    revokeAllConfirm: 'Bulk grants will be removed for the {n} user matching the current filter. This is NOT limited to the selection on the page; it covers everyone who matches. Continue? | Bulk grants will be removed for all {n} users matching the current filter. This is NOT limited to the selection on the page; it covers everyone who matches. Continue?',
    yesRemoveAll: 'Yes, remove all',
    removedAllSummary: '{users} user(s), {rows} row(s) removed ({n} matching user(s) processed)',
    bulkRemoveFailed: 'Error during bulk removal (may be partial)',
    verifyConfirm: '{n} user will be marked as reviewed and removed from the list. Continue? | {n} users will be marked as reviewed and removed from the list. Continue?',
    verifyConfirmTitle: 'Confirm review',
    yes: 'Yes',
    verifiedMessage: '{n} user marked as reviewed | {n} users marked as reviewed',
    revokeOneConfirm: 'Bulk grants for {email} will be removed. Are you sure?',
    revokeOneTitle: 'Remove single user',
    removed: 'Removed',
    restoreOneConfirm: 'The most recently removed bulk grant for {email} will be restored. Are you sure?',
    restoredRows: '{n} row restored | {n} rows restored',
    detailLoadFailed: 'Could not load details: {error}',
    allCanesUserScope: 'all canes (user-scope)',
    removePinConfirm: 'Pin {version} ({scope}) will be removed. Are you sure?',
    removePinTitle: 'Remove pin',
    pinRemoved: 'Pin removed',
    pinRemoveFailed: 'Could not remove pin: {error}',
    statusPending: 'Pending',
    statusRevoked: 'Removed (monitoring)',
    statusRestored: 'Restored',
    statusVerified: '✓ Verified',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: '{n} days ago',
    weeksAgo: '{n} wk ago'
  },
  campaigns: {
    featuresHelpIntro: 'Use one of two options for each feature:',
    durationDaysLabel: 'Duration (days):',
    durationDaysHelp: 'Active for this many days from the moment the user redeems the campaign.',
    fixedDateLabel: 'Fixed date:',
    fixedDateHelp: 'The feature ends on this date no matter when the user redeems it (end of the campaign period).',
    colDurationType: 'Duration type',
    colValue: 'Value',
    selectFeature: 'Select feature',
    modeDays: 'Days',
    modeDate: 'Date',
    daysExample: 'e.g. 14',
    daysUnit: 'days',
    endDate: 'End date',
    addFeature: 'Add feature',
    featureDurationRequired: 'Each feature needs a duration (days) or an end date',
    pastEndDateNotAllowed: 'An active campaign cannot have an end date in the past. Set the duration in days, pick a future date, or save the campaign as inactive.',
    durationDays: '{n} day | {n} days',
    untilDate: 'until {date}'
  },
  subscriptionAudit: {
    devToolTitle: 'Developer tool',
    devToolDescription: 'This page queries the Apple Server API and Google Play Developer API and compares subscription records with the DB. It is a read-only audit tool — it does not change any user data. Visible to super admins only.',
    runNewAudit: 'Run new audit',
    lookbackDays: 'Lookback (days)',
    maxSubs: 'Max subscriptions',
    startAudit: 'Start audit',
    refreshSummary: 'Refresh summary',
    asyncNote: 'The audit runs asynchronously. Because of Apple/Google API calls it can take a few minutes for hundreds of subscriptions. Meanwhile you can refresh the page or watch the findings table.',
    recentRuns: 'Recent audit runs',
    started: 'Started',
    colFindings: 'Findings',
    open: 'Open',
    openByType: 'Open findings (by type)',
    type: 'Type',
    count: 'Count',
    findingsTitle: 'Findings',
    openOnly: 'Open only',
    filter: 'Filter',
    reset: 'Reset',
    product: 'Product',
    expectedActual: 'Expected → Actual',
    storeDbExpiry: 'Store/DB expiry',
    storeStatus: 'Store status',
    date: 'Date',
    status: 'Status',
    resolved: 'Resolved',
    markResolved: 'Mark resolved',
    details: 'Details',
    findingDetails: 'Finding details',
    auditStarted: 'Audit started. It may take a few minutes; refresh the summary to see progress.',
    startFailed: 'Could not start audit',
    summaryLoadFailed: 'Could not load summary',
    findingsLoadFailed: 'Could not load findings',
    resolutionNote: 'Resolution note (optional):',
    markResolvedTitle: 'Mark as resolved',
    markedResolved: 'Marked as resolved'
  },
  common: {
    noData: 'No data available.',
    invalidUserType: 'Invalid user type.',
    invalidRequest: 'Invalid request.',
    unauthorized: 'Unauthorized access.',
    errorWithStatus: 'Error: {status}',
    errorOccurred: 'An error occurred: {message}',
    sessionEnded: 'Your session has ended.'
  },
  aimAnalytics: {
    title: 'AIM Analytics (BigQuery)',
    descIntro: 'Analytics summary of cane AIM reading data. Source: BigQuery',
    descTable: '(pre-aggregated day/device table).',
    superAdminOnly: 'Super admin only.',
    overview: 'Overview',
    totalReadings: 'Total readings',
    totalSessions: 'Total sessions',
    devices: 'Devices',
    users: 'Users',
    dataRange: 'Data range:',
    dayDeviceRecords: '({n} day/device records)',
    monthlyTrend: 'Monthly trend',
    month: 'Month',
    readings: 'Readings',
    sessions: 'Sessions',
    dailyTrend: 'Daily trend',
    lastNDays: 'Last {n} days',
    day: 'Day',
    mostActiveCanes: 'Most active canes',
    topN: 'Top {n}',
    caneId: 'Cane (cane_id)',
    activeDays: 'Active days',
    lastDay: 'Last day',
    loadSummaryFailed: 'Failed to load summary',
    loadDailyFailed: 'Failed to load daily data',
    loadCanesFailed: 'Failed to load cane list'
  },
  diagnostics: {
    title: 'Cane Diagnostics',
    introSnapshots: 'Diagnostic snapshots streamed from canes (battery, ultrasonic, obstacle detection, fault registers, firmware).',
    introUsage: 'Enter a serial number to see that device\'s time series, or use the filters to list all records.',
    serialPlaceholder: 'Serial no (e.g. WW-OZ-11267-000117)',
    source: 'Source',
    sourceMobileApp: 'Mobile app',
    sourceProductionPlatform: 'Production platform',
    startDate: 'Start date',
    endDate: 'End date',
    search: 'Search',
    reset: 'Reset',
    groupByCane: 'Group by cane',
    deviceLabel: 'Device:',
    total: 'Total',
    caneUnit: 'cane | canes',
    snapshotUnit: 'snapshot | snapshots',
    latestPerCane: '(showing the latest snapshot for each cane)',
    received: 'Received',
    serialNo: 'Serial no',
    production: 'Production',
    mobile: 'Mobile',
    battery: 'Battery',
    health: 'Health',
    clean: 'Clean',
    unregistered: 'Unregistered',
    unregisteredDevice: 'unregistered device',
    snapshots: 'Snapshots',
    details: 'Details',
    identity: 'Identity',
    registeredDevice: 'Registered device',
    notRegistered: 'NO (unregistered)',
    user: 'User',
    deviceTime: 'Device time',
    charge: 'Charge',
    voltage: 'Voltage',
    current: 'Current',
    faultRegisters: 'Fault registers',
    obstacleDetection: 'Obstacle detection',
    ultrasonic: 'Ultrasonic',
    firmwareSystem: 'Firmware / System',
    audio: 'Audio',
    rawPayload: 'Raw payload (hex)',
    snapshotDetails: 'Snapshot details',
    loadFailed: 'Failed to load snapshot list',
    uptimeHours: '{h}h {m}m',
    uptimeMinutes: '{m}m {s}s'
  },
  callEvents: {
    answeredCalls: 'Answered calls',
    missedCalls: 'Missed calls',
    failedCalls: 'Failed calls',
    failedCallsHint: 'Calls that never seem to have reached the assistant panel — the Zoom session got no joins at all (not even the caller connected)',
    noSubject: 'No subject selected',
    callId: 'Call ID',
    diagnosis: 'Diagnosis',
    regionCandidates: 'Region-matched candidates:',
    noRecordPrePhase2: 'no record (pre-Phase 2)',
    connectedAtTime: 'Connected at the time (broadcast sent):',
    panelsCaughtNewCall: 'Panels that caught \'new-call\':',
    hintNotConnected: 'Candidates > 0, Connected = 0 → no assistant panel was connected to WS at that moment (broadcast never sent)',
    hintPanelFailed: 'Connected > 0, Panel ack = 0 → socket existed but the panel could not process the message (UI/parse error, check Glitchtip)',
    hintNoAccept: 'Panel ack > 0, Zoom = 0 → panel saw it but no assistant accepted',
    diagNoRegionAssistant: 'No region-matched assistant',
    diagCandidatesNoneOnline: '{c} candidates, none online',
    diagConnectedPanelFailed: '{n}/{c} connected, panel failed to process',
    diagPanelsSawNobodyOpened: '{a}/{n} panels saw it, nobody opened',
    diagPanelsSawNotAnswered: '{a}/{n} panels saw it, not answered',
    diagPanelsSawJoins: '{a} panels saw it, {joined} joins',
    diagSentNoneConnected: 'Sent to {n} assistants, no one connected',
    diagSentNotAnswered: 'Sent to {n} assistants, not answered',
    diagNotifiedJoins: '{n} notified, {joined} joins',
    diagLegacyNoJoins: 'No joins (legacy record)',
    diagLegacyOneSide: 'One side only (legacy record)',
    diagLegacyJoins: '{joined} joins (legacy record)'
  },
  kpiAnalytics: {
    latestCombined: 'V2 latest + V3 latest combined',
    latestRowsHint: '— all of these rows count as "Latest"',
    channelBuildHint: 'beta groups are measured against their own build',
    registrationsInfo: 'Accounts that signed up in the selected date range (users.created_at). Name, email, phone and country can be used for outreach. Do not confuse with store install counts — those are anonymous totals.'
  },
  mobilityGroups: {
    trainerTraineeInfo: 'The teacher becomes the trainer and the students become trainees. A teacher sees their students\' data. A student sees their own data and their teacher\'s data, but not other students. A student can belong to more than one teacher.'
  },
  otaFilesExtra: {
    stableAllUsers: 'Stable (Default) — all users',
    groupCreateHint: 'Leave empty = stable (whole fleet). Select a group = members of that group only.',
    groupEditHint: 'Empty = stable (whole fleet). Clear this field to release a group build to everyone.',
    rolloutRandom: 'Random (%)',
    rolloutFirstCome: 'First come (count)',
    rolloutRandomHelp: 'Random: a fixed percentage of users based on the userId hash (the same users always stay in the group).',
    rolloutFirstComeHelp: 'First come: the first N users who request this version get it and stay on it; everyone after stays on the previous version.',
    firstNUsers: 'First N users',
    firstNUsersHint: 'Number of first users who will get this version (the previous active version must serve as fallback)',
    rolloutFirstN: 'First {n}',
    totalRequests: 'Total requests: {n}',
    groupCount: '{n} group | {n} groups',
    exportToExcel: 'Export to Excel',
    lastRequest: 'Last request',
    firstAt: 'first: {date}',
    requests: 'Requests',
    userDevice: 'User / Device',
    pinOnlyTagHint: 'Not distributed to everyone — only downloads when pinned to a user',
    managePins: 'Manage pins',
    managePinsFor: 'Manage pins - {name}',
    pinnedUsers: 'Users pinned to this OTA',
    addNewPin: 'Add new pin',
    searchUserPlaceholder: 'Search user (name, email, phone)',
    loadingUserDetails: 'Loading user details...',
    noActiveDevice: 'This user has no ACTIVE device - cannot pin.',
    noOtaSelected: 'No OTA selected',
    noRecordsToExport: 'No records to export',
    recordsExported: '{n} record exported | {n} records exported',
    excelExportFailed: 'Excel export failed: {error}',
    pinListLoadFailed: 'Failed to load pin list: {error}',
    userDetailsLoadFailed: 'Failed to load user details: {error}',
    allCanesUserScope: 'all canes (user-scope)',
    removePinConfirm: 'The {version} pin ({scope}) for {user} will be removed. Continue?',
    removePinTitle: 'Remove pin',
    confirmRemove: 'Yes, remove',
    cancel: 'Cancel',
    pinRemoved: 'Pin removed',
    pinRemoveFailed: 'Failed to remove pin: {error}'
  },
  caneAudio: {
    introTitle: 'Cane audio packs',
    introBody: 'The sound sets the app writes to the cane. The app reads this list, downloads the active version of the chosen language and voice, and checks size and sha256 before writing to the cane. A published version is never changed: to ship new sounds, upload a new version. Only the active version of each slot is offered to users.',
    kind_generic: 'Generic set',
    kind_english_primary: 'Built-in English',
    kind_language: 'Language pack',
    kindHint_generic: 'Horn, bell, beep and other non-speech sounds. Its version is what the cane reports as the generic version.',
    kindHint_english_primary: 'en-US female sentences written to the primary bank; the cane falls back to these.',
    versions: 'Versions',
    uploadVersion: 'Upload new version',
    upload: 'Upload',
    download: 'download',
    noActivePack: 'No active pack. The app cannot install this until a version is uploaded and activated.',
    noPack: 'no pack',
    searchPlaceholder: 'Search code, name, folder or alias',
    showInactive: 'Show inactive languages',
    refresh: 'Refresh',
    newLanguage: 'New language',
    languageCount: '{n} languages',
    code: 'Code',
    displayName: 'Name',
    backendKey: 'Backend key',
    otaFolder: 'Folder',
    manifestPrefix: 'Manifest prefix',
    synthesisCode: 'TTS locale',
    aliases: 'aliases',
    aliasesHelp: 'Legacy short codes stored on devices, comma separated (e.g. tr)',
    voicesHelp: 'Google TTS voice per slot. The phone speaks with this voice, so it must match the voice in the pack. A slot with no voice is not offered to users.',
    voicePlaceholder: 'e.g. tr-TR-Chirp3-HD-Aoede (empty = slot not offered)',
    slot_female: 'Female 1',
    slot_female2: 'Female 2',
    slot_male: 'Male 1',
    slot_male2: 'Male 2',
    sortOrder: 'Sort order',
    active: 'Active',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    edit: 'Edit',
    editLanguageTitle: 'Edit language {code}',
    close: 'Close',
    save: 'Save',
    saved: 'Saved',
    required: 'Required',
    version: 'Version',
    size: 'Size',
    uploadedAt: 'Uploaded',
    note: 'Note',
    editNote: 'Edit note',
    activate: 'Activate',
    deactivate: 'Deactivate',
    versionsHint: 'Activating a version deactivates the other versions of the same slot. Files stay in storage, so an older version can be activated again at any time.',
    uploadTitle: 'Upload a pack version',
    packKind: 'Pack type',
    language: 'Language',
    voiceSlot: 'Voice slot',
    versionHelp: 'Three numbers, major.minor.build (e.g. 2026.11.01). Written to the cane as three 32-bit numbers; letters are not allowed.',
    zipFile: 'Zip file',
    zipHelp: 'manifest.json plus the sound files at the zip root, nothing else. The server checks every file name and size against the manifest and the flash address chain before accepting it.',
    uploadRejected: 'The pack was not accepted',
    uploaded: 'Uploaded and activated',
    failed: 'That did not work'
  }
}
